import { forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import classNames from 'classnames'
import './textButton.css'

interface TextButtonProps {
  className?: string
  href?: string
  label: string
  onClick?: (evt: React.MouseEvent<HTMLElement>) => void
}

export const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ className, href, label, onClick }, ref) => {
    const navigate = useNavigate()

    const handleClick = (evt: React.MouseEvent<HTMLElement>) => {
      onClick?.(evt)
      if (href) {
        evt.preventDefault()
        navigate(href)
      }
    }

    return (
      <button
        ref={ref}
        className={classNames('text-button', className)}
        onClick={handleClick}
      >
        <span className="text-button-label">{label}</span>
      </button>
    )
  },
)
